import { Donor } from './donors';
import { http } from './http';

export type Receiver = {
  id: string;
  type: 'receiver';
  name: string;
  state: string;
  city: string;
  neighborhood: string;
  street: string;
  number: string;
  zipCode: string;
};

type Links = {
  self: string | null;
  first: string | null;
  prev: string | null;
  next: string | null;
  last: string | null;
};

export type PacksHistory = {
  id: string;
  collected_at: string;
  donor: Donor;
  updated_at: string;
}[];

export const fetchReceivers = async () => {
  const { data } = await http.get<Receiver[]>('/receivers');

  return data;
};

export const fetchPacks = async (receiverId: string, url?: string) => {
  const res = await http.get<PacksHistory>(url ?? `/donation/receivers/${receiverId}/packs`);
  const links = res.links as Links;

  return { packs: res.data, links };
};
